import React from "react";

import "./ModalQuestionContainer.scss";

export default class ModalQuestionContainer extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    renderGuessNumber(description, answer, handleAnswerChange) {
        return (
            <div>
                <label
                    className="entry-modal-question-description"
                    htmlFor={`entry-modal-question-input-${description}`}
                >
                    {description}
                </label>

                <input
                    type="number"
                    step="1"
                    className="entry-modal-question-input"
                    id={`entry-modal-question-input-${description}`}
                    name="guess_number"
                    value={answer}
                    onChange={handleAnswerChange}
                >
                </input>
            </div>
        );
    }

    renderFreeForm(description, answer, handleAnswerChange) {
        return (
            <div>
                <label
                    className="entry-modal-question-description"
                    htmlFor={`entry-modal-question-input-${description}`}
                >
                    {description}
                </label>

                <input
                    type="text"
                    className="entry-modal-question-input"
                    id={`entry-modal-question-input-${description}`}
                    name="free_form"
                    value={answer}
                    onChange={handleAnswerChange}
                >
                </input>
            </div>
        );
    }

    renderMultipleChoice(description, options, answer, handleAnswerChange) {
        const checkboxes = options.map((option, index) => {
            return (
                option
                && <div className="entry-modal-question-checkbox-container" key={index}>
                    <input
                        type="checkbox"
                        className="entry-modal-question-checkbox"
                        id={`entry-modal-question-checkbox-${index},${option}`}
                        name="multiple_choice"
                        value={option}
                        onChange={handleAnswerChange}
                        checked={answer.includes(option)}
                    >
                    </input>

                    <label
                        className="entry-modal-question-label"
                        htmlFor={`entry-modal-question-checkbox-${index},${option}`}
                    >
                        {option}
                    </label>
                </div>
            );
        });

        return (
            <div>
                <div className="entry-modal-question-description">{description}</div>

                {checkboxes}
            </div>
        );
    }

    render() {
        const {type, description, options, answer, handleAnswerChange} = this.props;

        const content = (
            type === "guess_number"
            ? this.renderGuessNumber(description, answer, handleAnswerChange)
            : type === "free_form"
            ? this.renderFreeForm(description, answer, handleAnswerChange)
            : type === "multiple_choice"
            ? this.renderMultipleChoice(description, options, answer, handleAnswerChange)

            // Fallback for if the question type somehow hasn't been set correctly.
            : undefined
        );

        return (
            <div className="entry-modal-question-container">
                {content}
            </div>
        );
    }
}
